export const profile = {
  name: 'Keith Kohl',
  headline:
    'Strategic Product Leader | SVP & Board Advisor | Transforming Enterprise SaaS, AI & Data Ecosystems',
  subheadline:
    'Scaling global software portfolios from early-stage expansion to $600M+ enterprise valuations. Specialized in AI transformation, portfolio monetization, M&A due diligence, and PE-backed exit readiness.',
  portrait: 'https://cdn.magicpatterns.com/uploads/mG1ysDtzdQsGkyHzxVNw7p/keith3.jpg',
  email: 'kdkohl@yahoo.com',
  location: 'Rehoboth Beach, DE · Remote · Boston · New York',
  linkedin: 'https://www.linkedin.com/',
  linkedinLabel: 'linkedin.com/in/keithkohl',
}

export interface SectionLink {
  number: string
  path: string
  label: string
  title: string
  blurb: string
}

export const sections: SectionLink[] = [
  {
    number: '01',
    path: '/',
    label: 'Profile',
    title: 'Executive Profile',
    blurb: 'Portrait, positioning, and the headline numbers behind a 25-year career.',
  },
  {
    number: '02',
    path: '/about',
    label: 'About',
    title: 'About Keith',
    blurb: 'A first-person account of how complex technology becomes enterprise value.',
  },
  {
    number: '03',
    path: '/impact',
    label: 'Impact',
    title: 'Executive Impact',
    blurb: 'Revenue scale, acquisitions integrated, and measurable portfolio outcomes.',
  },
  {
    number: '04',
    path: '/expertise',
    label: 'Expertise',
    title: 'Core Competencies',
    blurb: 'Four pillars behind every portfolio built, repositioned, and scaled.',
  },
  {
    number: '05',
    path: '/experience',
    label: 'Experience',
    title: 'Professional Experience',
    blurb: 'The full record, from IBM mainframe engineering to the SVP chair.',
  },
  {
    number: '06',
    path: '/corporate-development',
    label: 'M&A',
    title: 'M&A & Corporate Development',
    blurb: 'CIM authorship, technical due diligence, and post-merger integration.',
  },
  {
    number: '07',
    path: '/skills',
    label: 'Skills',
    title: 'Skills & Endorsements',
    blurb: 'Peer-validated capability, ranked by endorsement across three decades.',
  },
  {
    number: '08',
    path: '/education',
    label: 'Education',
    title: 'Education & Credentials',
    blurb: 'Purdue computer science, Pragmatic Institute, and Agile certification.',
  },
  {
    number: '09',
    path: '/philosophy',
    label: 'Philosophy',
    title: 'Leadership Philosophy',
    blurb: 'How product leadership is practiced, and what it is accountable for.',
  },
  {
    number: '10',
    path: '/contact',
    label: 'Contact',
    title: 'Contact & Availability',
    blurb: 'Board appointments, executive advisory, and C-suite leadership roles.',
  },
]
